import { currencyFormatRp } from 'helpers/currency'

export const INCENTIVE_PAYSLIP_HEADER = {
  title: 'Incentive Payslip Preview',
  lastUpdated: '01 January 2025, 01:00',
}

export const INCENTIVE_INFORMATION_FIELDS = [
  { label: 'Nama Pegawai', value: '-' },
  { label: 'ID Pegawai', value: '-' },
  { label: 'Lokasi', value: '-' },
  { label: 'Periode Komisi', value: '-' },
  { label: 'NIK KTP', value: '-' },
  { label: 'Informasi Transfer', value: '-' },
] as const

export const INCENTIVE_ITEMS = [
  { label: 'Performance Incentive', value: 0 },
  { label: 'Attendance Incentive', value: 0 },
  { label: 'Incentive Arrears', value: 0 },
  { label: 'Additional Incentive', value: 0 },
  { label: 'Special Incentive', value: 0 },
].map((item) => ({ ...item, valueFormatted: currencyFormatRp(item.value) }))

export const DEDUCTION_ITEMS = [
  { label: 'Potongan Lainnya', value: 0 },
  { label: 'Informasi Potongan', value: 0 },
].map((item) => ({ ...item, valueFormatted: currencyFormatRp(item.value) }))
